import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
// MỘT file CSS duy nhất. Tailwind v4 phân giải `@apply` dựa trên
// `@import "tailwindcss"` trong CÙNG file — tách ra file thứ hai thì phải
// thêm `@reference`, dễ sót. Một file 5KB thì không đáng tách.
import './styles/theme.css'

// Không đăng ký service worker ở bước này.
//
// Đồng hồ đếm ngược chạy ở client và đáp án gửi lên server ngay khi chọn, nên
// app vẫn dùng được khi mất mạng giữa chừng — nhưng "dùng được" khác "dùng
// offline". Không có service worker thì mở app khi offline là trang trắng.
// Đó là hạng mục riêng, làm sau: thêm service worker mà quên cache lại chính
// câu hỏi thì lúc mất mạng app mở được rồi báo lỗi — tệ hơn hẳn không có.
const root = document.getElementById('root')
if (!root) throw new Error('khong tim thay #root')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
